import clsx from "clsx";
import FormFooter from "components/FormFooter";
import FormHeader from "components/FormHeader";
import Logo from "components/Logo";
import { observer } from "mobx-react";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";

const AuthLayout = ({
  children,
  heading,
  subHeading,
  footerHeading,
  footerSubHeading,
  showSignUpLink = false,
}) => {
  return (
    <>
      <div
        className={clsx(
          "flex h-full w-full items-center justify-center bg-gray-100",
        )}
      >
        <div
          className={clsx(
            "flex  h-screen w-screen flex-col items-center justify-center md:flex-row",
          )}
        >
          <div
            className={clsx(
              " no-scrollbar hidden-scrollbar h-full overflow-y-auto md:w-1/2 w-full",
            )}
          >
            <div className={clsx("mx-auto max-w-lg px-6 py-16")}>
              <header className={clsx("py-4")}>
                <Link
                  href="/"
                  className={clsx("mx-auto mb-4 block w-full max-w-[60px]")}
                >
                  <Logo fill="#fff" />
                </Link>
                <FormHeader heading={heading} subHeading={subHeading} />
                {showSignUpLink && <_SignUpLink />}
              </header>
              <div className={clsx("")}>{children}</div>
              {showSignUpLink && (
                <div className={clsx("mt-4")}>
                  <_SignUpLink />
                </div>
              )}
              {(!!footerHeading || !!footerSubHeading) && (
                <footer className={clsx("pt-6")}>
                  <FormFooter
                    heading={footerHeading}
                    subHeading={footerSubHeading}
                  />
                </footer>
              )}
            </div>
          </div>
          <div
            className={clsx("relative hidden h-full md:block md:w-1/2 w-full")}
          >
            <Image
              src="/images/cards.jpg"
              layout="fill"
              objectFit="cover"
              alt="YCN"
              priority
              sizes="100vw"
            />
          </div>
        </div>
      </div>
    </>
  );
};

const _SignUpLink = () => {
  return (
    <div className={clsx("text-center text-gray-400")}>
      Already signed up?{" "}
      <Link href="/auth/signin" className={clsx("link")}>
        Login here
      </Link>
      .
    </div>
  );
};

export default observer(AuthLayout);
